import React from "react";
import _ from "lodash";

class EmailInput extends React.Component {
    constructor(props) {
        super(props);
    }
 
    handleValidate = _.debounce((e) => {
        const { onValidate } = this.props;

        if (onValidate) {
            onValidate(e)
        }

    }, 400);

    handleChange = (e) => {
        const { onChange } = this.props;
        onChange(e);
        
        e.persist();

        this.handleValidate(e);
    }

    render() {
        const { name, value, placeholder, classes }= this.props;

        return (
            <input type="text"
                className={classes}
                value={value}
                name={name} placeholder={placeholder} 
                onChange={this.handleChange}
                maxLength={300}
            />
        );
    }
}

export default EmailInput;
